import axios from 'axios';
import { AppLocalStorage } from '../utils/localStorage';
import { host } from './routes';

const httpClient = axios.create({
  baseURL: host,
})

httpClient.interceptors.request.use(config => {
  const token = AppLocalStorage.getLSToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default httpClient;
